function JourneyEnd({ animate }) {
   return (
      <>
         <div className="flex journeyend">
            <div className="col">
               <h2>The journey doesn't end there</h2>
               <p>
                  We know you’re going to love your new home and being part of
                  an amazing new neighbourhood – it’s the place to be. Our
                  dedicated customer services team will be on hand to support
                  you from the day you move in and beyond. You’ll also be able
                  tell us how we did, by filling in our customer survey.
               </p>
               <ul className="styled-list">
                  <li>1 week check-in</li>
                  <li>1 month check-in</li>
                  <li>1 year anniversary check-in</li>
                  <li>2 year anniversary check-in</li>
               </ul>
            </div>
         </div>
         <div className="usefullinks">
            <h2>Useful links</h2>
            <div className="usefullinks__container">
               <div>
                  <h3>Happy house hunting</h3>
                  <p>Start your search for your brand-new home.</p>
                  <a
                     href="/"
                  >
                     Find my home
                  </a>
               </div>
               <div>
                  <h3>My Miller Home</h3>
                  <p>
                     Register with us to keep up to date with exclusive news and
                     offers.
                  </p>
                  <a
                     href="/register.aspx"
                  >
                     Register now
                  </a>
               </div>
               <div>
                  <h3>Pre-reserve your dream home</h3>
                  <p>
                     Find out how easy it is to pre-reserve your new home online.
                  </p>
                  <a
                     href="/what-makes-us-different/online-reservations.aspx"
                  >
                     Pre-reserve my home
                  </a>
               </div>
               <div>
                  <h3>The money bit</h3>
                  <p>
                     Get in touch with an independent financial adviser or
                     solicitor or make use of our stamp duty and mortgage
                     calculators.
                  </p>
                  <a
                     href="/help-and-advice.aspx"
                  >
                     Work out my finances
                  </a>
               </div>
               <div>
                  <h3>Your home, your way</h3>
                  <p>
                     Use our visualiser tool to start choosing the options for
                     your dream home.
                  </p>
                  <a
                     href="/what-makes-us-different/options-and-extras.aspx"
                  >
                     Visualise my options
                  </a>
               </div>
            </div>
         </div>
         <div>
            <img
               src="/ReactAssets/CustomerJourney/consumer-code.png"
               alt="Consumer Code For Home Builders | Approved Code TradingStandards.UK"
               width="50%"
               style={{ display: 'block', maxWidth: '300px', margin: '0 auto' }}
            />
         </div>
      </>
   );
}

export default JourneyEnd;
